/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ChangeFailureStatusRulesCommand,
    ChangeFailureStatusRulesCommandFromJSON,
    ChangeFailureStatusRulesCommandToJSON,
    CreateFailureStatusCommand,
    CreateFailureStatusCommandFromJSON,
    CreateFailureStatusCommandToJSON,
    ExceptionDto,
    ExceptionDtoFromJSON,
    ExceptionDtoToJSON,
    FailureStatusDto,
    FailureStatusDtoFromJSON,
    FailureStatusDtoToJSON,
    FailureStatusRulesResponseVm,
    FailureStatusRulesResponseVmFromJSON,
    FailureStatusRulesResponseVmToJSON,
    FailureStatusVm,
    FailureStatusVmFromJSON,
    FailureStatusVmToJSON,
    FailureTaskVmPaginatedSearchResponse,
    FailureTaskVmPaginatedSearchResponseFromJSON,
    FailureTaskVmPaginatedSearchResponseToJSON,
    GetAllFailureStatusesQuery,
    GetAllFailureStatusesQueryFromJSON,
    GetAllFailureStatusesQueryToJSON,
} from '../models';

export interface ApiFailureStatusChangeRulesPutRequest {
    changeFailureStatusRulesCommand?: ChangeFailureStatusRulesCommand;
}

export interface ApiFailureStatusFailureSatusPostRequest {
    createFailureStatusCommand?: CreateFailureStatusCommand;
}

export interface ApiFailureStatusGetAllPostRequest {
    getAllFailureStatusesQuery?: GetAllFailureStatusesQuery;
}

export interface ApiFailureStatusIdDeleteRequest {
    id: string;
}

export interface ApiFailureStatusIdGetRequest {
    id: string;
}

export interface ApiFailureStatusIdPutRequest {
    id: string;
    failureStatusDto?: FailureStatusDto;
}

/**
 * 
 */
export class FailureStatusApi extends runtime.BaseAPI {

    /**
     * Change failure status rules.
     */
    async apiFailureStatusChangeRulesPutRaw(requestParameters: ApiFailureStatusChangeRulesPutRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/FailureStatus/ChangeRules`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeFailureStatusRulesCommandToJSON(requestParameters.changeFailureStatusRulesCommand),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Change failure status rules.
     */
    async apiFailureStatusChangeRulesPut(requestParameters: ApiFailureStatusChangeRulesPutRequest): Promise<void> {
        await this.apiFailureStatusChangeRulesPutRaw(requestParameters);
    }

    /**
     * Create a failure status
     */
    async apiFailureStatusFailureSatusPostRaw(requestParameters: ApiFailureStatusFailureSatusPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/FailureStatus/FailureSatus`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFailureStatusCommandToJSON(requestParameters.createFailureStatusCommand),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Create a failure status
     */
    async apiFailureStatusFailureSatusPost(requestParameters: ApiFailureStatusFailureSatusPostRequest): Promise<string> {
        const response = await this.apiFailureStatusFailureSatusPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get all failure tasks.
     */
    async apiFailureStatusGetAllPostRaw(requestParameters: ApiFailureStatusGetAllPostRequest): Promise<runtime.ApiResponse<FailureTaskVmPaginatedSearchResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/FailureStatus/GetAll`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAllFailureStatusesQueryToJSON(requestParameters.getAllFailureStatusesQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FailureTaskVmPaginatedSearchResponseFromJSON(jsonValue));
    }

    /**
     * Get all failure tasks.
     */
    async apiFailureStatusGetAllPost(requestParameters: ApiFailureStatusGetAllPostRequest): Promise<FailureTaskVmPaginatedSearchResponse> {
        const response = await this.apiFailureStatusGetAllPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get failure status rules.
     */
    async apiFailureStatusGetAllRulesPostRaw(): Promise<runtime.ApiResponse<FailureStatusRulesResponseVm>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/FailureStatus/GetAllRules`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FailureStatusRulesResponseVmFromJSON(jsonValue));
    }

    /**
     * Get failure status rules.
     */
    async apiFailureStatusGetAllRulesPost(): Promise<FailureStatusRulesResponseVm> {
        const response = await this.apiFailureStatusGetAllRulesPostRaw();
        return await response.value();
    }

    /**
     * The endpoint basic results in Microsoft.AspNetCore.Mvc.NoContentResult
     * Delete the item signed with the id.
     */
    async apiFailureStatusIdDeleteRaw(requestParameters: ApiFailureStatusIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiFailureStatusIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/FailureStatus/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * The endpoint basic results in Microsoft.AspNetCore.Mvc.NoContentResult
     * Delete the item signed with the id.
     */
    async apiFailureStatusIdDelete(requestParameters: ApiFailureStatusIdDeleteRequest): Promise<void> {
        await this.apiFailureStatusIdDeleteRaw(requestParameters);
    }

    /**
     * Gets the requested instance, identified by id.
     */
    async apiFailureStatusIdGetRaw(requestParameters: ApiFailureStatusIdGetRequest): Promise<runtime.ApiResponse<FailureStatusVm>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiFailureStatusIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/FailureStatus/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FailureStatusVmFromJSON(jsonValue));
    }

    /**
     * Gets the requested instance, identified by id.
     */
    async apiFailureStatusIdGet(requestParameters: ApiFailureStatusIdGetRequest): Promise<FailureStatusVm> {
        const response = await this.apiFailureStatusIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update the current instance with the fulfilled model
     */
    async apiFailureStatusIdPutRaw(requestParameters: ApiFailureStatusIdPutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiFailureStatusIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/FailureStatus/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FailureStatusDtoToJSON(requestParameters.failureStatusDto),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the current instance with the fulfilled model
     */
    async apiFailureStatusIdPut(requestParameters: ApiFailureStatusIdPutRequest): Promise<void> {
        await this.apiFailureStatusIdPutRaw(requestParameters);
    }

}
